import apiClient from '../../services/apiClientService';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useTenant } from '../../contexts/TenantContext';

// The menu item spins until this call answers, so it must not hang for as long as the browser would.
const LOGOUT_TIMEOUT_MS = 5000;

/**
 * Ends the session on the server. The auth cookie is httpOnly, so the page cannot remove it
 * itself: only the response to this call can.
 */
const useLogout = () => {
  const { tenantId } = useTenant();
  const { handleError } = useErrorHandler();

  const logout = async () => {
    try {
      const url = `/v1/public/tenants/${tenantId}/auth/logout`;
      await apiClient.post(url, null, { timeout: LOGOUT_TIMEOUT_MS });
      return true;
    } catch (err) {
      handleError(err);
      return false;
    }
  };

  return { logout };
};

export default useLogout;
